/**
 * Online store, session B2 — „ონლაინ შეკვეთები": the orders a buyer placed
 * on the shop's website, as the till walks them (lib/online-orders.ts).
 * Money arrives as a formatted `{sum}`. The sale's „მიტანა" line is a
 * document word and stays Georgian (DELIVERY_LINE in lib/online-orders).
 */
export const orders = {
  'oo.search': 'ძებნა — ნომერი, სახელი ან ტელეფონი',
  'oo.filter.open': 'ღია',
  'oo.filter.all': 'ყველა',
  'oo.empty': 'ონლაინ შეკვეთები ჯერ არ არის',
  'oo.emptyOpen': 'ღია შეკვეთა არ არის — დახურულები „ყველაში" ჩანს',
  'oo.refresh': 'განახლება',
  'oo.newCount': '{n} ახალი',

  'oo.st.new': 'ახალი',
  'oo.st.confirmed': 'დადასტურებული',
  'oo.st.shipped': 'გაგზავნილი',
  'oo.st.delivered': 'ჩაბარებული',
  'oo.st.cancelled': 'გაუქმებული',

  'oo.go.confirmed': 'დადასტურება',
  'oo.go.shipped': 'გაგზავნა',
  'oo.go.cancelled': 'გაუქმება',
  'oo.go.sell': 'გაყიდვა · {sum}',

  'oo.delivery.courier': 'მიტანა',
  'oo.delivery.pickup': 'მაღაზიიდან წაღება',
  'oo.pay.on_delivery': 'გადახდა მიტანისას',
  'oo.pay.transfer': 'გადმორიცხვით',
  'oo.pay.at_shop': 'გადახდა მაღაზიაში',

  'oo.f.buyer': 'მყიდველი',
  'oo.f.phone': 'ტელეფონი',
  'oo.f.address': 'მისამართი',
  'oo.f.note': 'შენიშვნა',
  'oo.f.receive': 'მიღება',
  'oo.f.payment': 'გადახდა',
  'oo.f.placed': 'შეკვეთილია {when}',
  'oo.f.purged': 'მყიდველის მონაცემები წაშლილია',
  'oo.items': 'ნივთები',
  'oo.fee': 'მიტანა',
  'oo.feeFree': 'უფასო',
  'oo.total': 'სულ',
  'oo.short': 'მარაგი აღარ ყოფნის',
  'oo.shortHint': 'თაროზე ამდენი აღარ არის — დაურეკე მყიდველს ან გააუქმე შეკვეთა.',
  'oo.call': 'დარეკვა',
  'oo.history': 'ისტორია',
  'oo.byBuyer': 'მყიდველი',
  'oo.cancelReason': 'მიზეზი: {reason}',

  'oo.reason': 'გაუქმების მიზეზი',
  'oo.reasonPh': 'მაგ. მყიდველმა გადაიფიქრა',
  'oo.branch': 'რომელი ფილიალიდან',
  'oo.moved': 'შეკვეთა {no} — {st}',
  // a new order reaches the till by itself (lib/order-alerts.ts)
  'oo.alert.one': 'ახალი ონლაინ შეკვეთა {no} · {sum}',
  'oo.alert.many': '{n} ახალი ონლაინ შეკვეთა',
  'oo.alert.view': 'ნახვა',
  'oo.alert.badge': '{n} უპასუხო შეკვეთა',

  'oo.sell.title': 'შეკვეთა {no} — გაყიდვა',
  'oo.sell.hint': 'გაიყიდება ზუსტად შეკვეთა, მისი ფასებით. შეკვეთა იმავე წამს ჩაბარდება.',
  'oo.sell.cash': 'ნაღდი',
  'oo.sell.card': 'ბარათი',
  'oo.sell.bank': 'ბანკი',
  'oo.sell.go': 'გაყიდვა · {sum}',
  'oo.sell.done': 'შეკვეთა {no} გაიყიდა და ჩაბარდა',
  'oo.sell.print': 'ქვითარი',
  'oo.sell.noShift': 'გასაყიდად ჯერ გახსენი ცვლა სალაროში.',
  'oo.sell.openShift': 'სალაროში გადასვლა',
  'oo.sell.offline': 'ონლაინ შეკვეთა მხოლოდ ინტერნეტით იყიდება — ოფლაინ რიგში არ ჩადგება.',
  'oo.sell.lost': 'კავშირი გაწყდა — დააჭირე ხელახლა. შეკვეთა ორჯერ არ გაიყიდება.',
  'oo.sell.transfer': 'მყიდველმა გადმორიცხვა აირჩია. გადმორიცხვის ჩაწერის გზას მფლობელი ჯერ ირჩევს — მანამდე ასეთი შეკვეთა სალაროში არ იყიდება.',

  'oo.err.mismatch': 'შეკვეთა სალაროში შეცვლილი სახით მივიდა — განაახლე სია და სცადე თავიდან.',
  'oo.err.closed': 'ეს შეკვეთა უკვე დახურულია.',
  'oo.err.branch': 'ეს შეკვეთა სხვა ფილიალისთვისაა დადასტურებული — აირჩიე ის ფილიალი.',
  'oo.err.move': 'ეს ნაბიჯი ამ შეკვეთისთვის აღარ შეიძლება — განაახლე სია.',
  'oo.err.gone': 'შეკვეთის ნივთი სისტემიდან წაშლილია — შეკვეთა გააუქმე.',
  'oo.err.notFound': 'შეკვეთა ვერ მოიძებნა.',
  'oo.err.terms': 'ონლაინ შეკვეთა იყიდება მისი ფასით — ფასდაკლების, ბონუსის და აქციის გარეშე.',
  'oo.err.reason': 'ჩაწერე გაუქმების მიზეზი.',
  'oo.err.load': 'შეკვეთები ვერ ჩაიტვირთა',
  'oo.err.save': 'შეკვეთა ვერ შეიცვალა',
} as const
